import { useEffect, useState } from "react";
import { useAppState } from "contexts/UserContext.js";
import { useAuth } from "contexts/AuthContext";
import { useCause } from "contexts/CauseContext";

import { useUserCauses } from "./useUserCauses";
import { useMoodImages } from "./useMoodImages";
import { useRelevantMoods } from "./useRelevantMoods";
import { useUserAndLeadSubscriptionCheck } from "./useUserAndLeadSubscriptionCheck";
import { usePushTokenRegistration } from "./usePushTokenRegistration";

export function useHomeData() {
  const { moods, selectedDate, setSelectedDate, themeId } = useAppState();
  const { userId, email } = useAuth();
  const { setCauses } = useCause();

  const { causes } = useUserCauses(userId);
  useEffect(() => {
    setCauses(causes);
  }, [causes, setCauses]);

  const { moodImages, feelingNames, imagesReady } = useMoodImages(
    themeId,
    selectedDate
  );
  const relevantMoods = useRelevantMoods(
    moods,
    selectedDate,
    userId,
    feelingNames
  );

  const [isVisible, setIsVisible] = useState(true);

  const { isLoading, leadUid, isLoadingLeadUid } =
    useUserAndLeadSubscriptionCheck({ userId });

  usePushTokenRegistration(userId, email);

  useEffect(() => {
    if (leadUid) {
      console.log("leadUid retrieved: ", leadUid);
    }
  }, [leadUid]);

  return {
    moodImages,
    relevantMoods,
    feelingNames,
    imagesReady,

    selectedDate,
    setSelectedDate,

    isVisible,

    isLoading,
    leadUid,
    isLoadingLeadUid,
  };
}
